/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Grid_Add_ItemInputs */

const cs_builder_grid_add_item = /** @type {(inputs: Builder_Grid_Add_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat položku`)
};

const en_builder_grid_add_item = /** @type {(inputs: Builder_Grid_Add_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add item`)
};

/**
* | output |
* | --- |
* | "Add item" |
*
* @param {Builder_Grid_Add_ItemInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_grid_add_item = /** @type {((inputs?: Builder_Grid_Add_ItemInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Grid_Add_ItemInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_grid_add_item(inputs)
	return cs_builder_grid_add_item(inputs)
});